import StoreSystemIdList from "../component/StoreSystemIdList";
import React from "react";

const StoreSystemIdListContainer = ({ pageId }) => (<StoreSystemIdList pageId={pageId}/>)

export default StoreSystemIdListContainer;